module.exports = __webpack_public_path__ + "87a563c6547845b1e1fe16ebc71b62fd.png";